import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { invitationStatus } from '../../../../../constants';
import { InputFormField } from '../../../../../containers/components';
import { businessActions, businessSelector } from '../../../../../state/modules/business';
import { FormSubmissionMessage } from '../../../../components';
import Loading from '../../../loading';


const ResendInvitation = ({
  invitationId,
  confirmResendInvitation,
  changeResendInvitationEmail,
  changeResendInvitationFirstName,
  changeResendInvitationLastName,
  resendingInvitation,
  resendingInvitationEmail,
  resendingInvitationFirstName,
  resendingInvitationLastName,
  email,
  resendError,
  resendSuccess,
  show,
  closeModal,
  hideMessage,
  isResendingInvitations
}) => (
    <Modal show={show} onHide={closeModal} dialogClassName='invite-team-member-modal'>
      <Modal.Header>
        <Modal.Title componentClass='h2' className='text-center'>
          Resend Invitation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='text-center'>
        <form noValidate onSubmit={confirmResendInvitation}>
          <Row className='sm-gutter'>
            <Col xs={12} md={4}>
              <InputFormField
                id='resendEmail'
                value={resendingInvitationEmail}
                label='Email'
                onChange={(e) => changeResendInvitationEmail(e.target.value)}
              />
            </Col>
            <Col xs={12} md={4}>
              <InputFormField
                id='resendFirstName'
                value={resendingInvitationFirstName}
                label='First Name'
                onChange={(e) => changeResendInvitationFirstName(e.target.value)}
              />
            </Col>
            <Col xs={12} md={4}>
              <InputFormField
                id='resendLastName'
                value={resendingInvitationLastName}
                label='Last Name'
                onChange={(e) => changeResendInvitationLastName(e.target.value)}
              />
            </Col>
          </Row>
          <FormSubmissionMessage
            showSubmissionMessage={resendError || resendSuccess}
            submissionMessage={resendError ? resendError : resendSuccess}
            error={resendError}
            hideSubmissionMessage={hideMessage} />
        </form>
      </Modal.Body>
      <Modal.Footer className='text-center confirmation-footer'>
        {
          !resendSuccess ?
            <Row>
              <Col xs={12}>
                <Button onClick={confirmResendInvitation}>
                  {
                    isResendingInvitations ?
                      <Loading /> :
                      'Resend Invitation'
                  }
                </Button>
              </Col>
            </Row> :
            null
        }
        <Row>
          <Col xs={12}>
            <Button bsStyle='plain' onClick={closeModal}>
              {
                resendSuccess ?
                  'Close' :
                  'Cancel'
              }
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );

const mapStateToProps = (state) => ({
  invitations: fp.filter(({ status }) => fp.eq(status)(invitationStatus.Sent))(state.business.invitations),
  isResendingInvitations: state.business.isResendingInvitations,
  resendingSuccess: state.business.resendingSuccess,
  teamMembers: fp.map(({ user }) => ({
    ...user
  }))(state.business.teamMembers) || [],
  currentUser: state.user.currentUser,
  business: businessSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
  resendInvitation: bindActionCreators(businessActions.business.resendInvitation, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers({
    resendingInvitationEmail: null,
    resendingInvitationFirstName: null,
    resendingInvitationLastName: null,
    resendError: null,
    resendSuccess: null,
    removingUser: null,
    searchText: '',
    showButtons: []
  }, {
      changeResendInvitationEmail: () => (resendEmail) => ({
        resendingInvitationEmail: resendEmail
      }),
      changeResendInvitationFirstName: () => (resendFirstName) => ({
        resendingInvitationFirstName: resendFirstName
      }),
      changeResendInvitationLastName: () => (resendLastName) => ({
        resendingInvitationLastName: resendLastName
      }),
      setResendMessage: () => (isSuccess, message) => ({
        resendError: isSuccess ? null : message,
        resendSuccess: isSuccess ? message : null
      }),
      hideMessage: () => () => ({
        resendSuccess: null,
        resendError: null
      })
    }
  ),
  withHandlers({
    confirmResendInvitation: ({
      business,
      resendInvitation,
      invitationId,
      resendingInvitationEmail,
      resendingInvitationFirstName,
      resendingInvitationLastName,
      setResendMessage,
      invitations,
      teamMembers
    }) => (e) => {
      e.preventDefault();
      e.stopPropagation();
      const existingInvitationWithEmail = fp.find(({ id, email }) => (email === resendingInvitationEmail && id !== invitationId))(invitations)
      const existingUserWithEmail = fp.find(({ email }) => email === resendingInvitationEmail)(teamMembers)

      if (existingInvitationWithEmail || existingUserWithEmail) {
        return setResendMessage(false, "Email exists on another user or invitation")
      }
      const invitation = fp.find(({ id }) => id === invitationId)(invitations)
      resendInvitation(business.id, {
        ...invitation,
        email: resendingInvitationEmail,
        firstName: resendingInvitationFirstName,
        lastName: resendingInvitationLastName
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      const {
        user: { email, firstName, lastName },
        changeResendInvitationEmail,
        changeResendInvitationFirstName,
        changeResendInvitationLastName,
        hideMessage
      } = this.props;
      changeResendInvitationEmail(email);
      changeResendInvitationFirstName(firstName);
      changeResendInvitationLastName(lastName);
      hideMessage();
    },
    componentWillReceiveProps(nextProps) {
      const {
        show: wasShown,
        isResendingInvitations: wasResendingInvitations
      } = this.props;
      const {
        show: isShown,
        user: { email, firstName, lastName },
        hideMessage,
        changeResendInvitationEmail,
        changeResendInvitationFirstName,
        changeResendInvitationLastName,
        resendingSuccess,
        setResendMessage,
        isResendingInvitations
      } = nextProps;
      if ((!isResendingInvitations && wasResendingInvitations)) {
        setResendMessage(resendingSuccess, resendingSuccess ? "Invitation sent" : "Resending invitation falied");
      }
      if (wasShown !== isShown) {
        hideMessage();
        changeResendInvitationEmail(email);
        changeResendInvitationFirstName(firstName);
        changeResendInvitationLastName(lastName);
      }
    }
  })
)(ResendInvitation);



// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/components/resend-invitation.js